import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { CrudService } from "@app/services/crud.service";
import { CrudController, ICrudScope } from "@app/views/crud.view";
import { eViewType, ICustomer } from "@models";
import { icons } from "@tools";

export interface ICustomerScope extends ICrudScope<ICustomer> {
    customerTypes: string[];
}

@NgView({
    token: Token.CustomerView,
    inherit: [Token.CrudView]
})
export class CustomerController extends CrudController<ICustomer> {
    constructor(
        public $scope: ICustomerScope,
        crudService: CrudService,
        model: ICustomer
    ) {

        super(
            $scope,
            crudService,
            model);

        this.drawerService.setHelpUrl("Customers");

        let viewType = this.$state.current.data.viewType;

        if ($scope.model) {
            crudService.$rootScope.setTitle($scope.model.name);
            this.deleteMsg = loc.msg_deleterecord.format(loc.customer_title, $scope.model.name);
        }

        if (viewType == eViewType.new) {
            crudService.$rootScope.setTitle(loc.create + " " + loc.customer_title);

            $scope.model = {
                idCompany: this.$rootScope.company.id,
                name: "New Customer",
                shipToBillingAddress: true,
                type: loc.customer_type_direct
            } as any;
        }

        // customerTypes
        this.$http.get<string[]>("/api/customers/types").then(response => {
            $scope.customerTypes = response.data;
        });

        // add drawers
        if ($scope.isEdit || $scope.isNew) {
            let drDelete = this.drawerService.addDrawer(icons.deleter, loc.deleter, $scope.delete, $scope.isEdit);
            let drSave = this.drawerService.addDrawer(icons.save, loc.save, $scope.save);
            let drCancel = this.drawerService.addDrawer(icons.cancel, loc.cancel, $scope.cancel);
        } else {
            let drEdit = this.drawerService.addDrawer(icons.edit, loc.edit, () => {
                this.$state.go("kb.admin.customerEdit", { id: $scope.model.id });
            }, this.$rootScope.user.canModifyCustomers);
            let drDelete = this.drawerService.addDrawer(
                icons.deleter,
                loc.deleter,
                $scope.delete,
                this.$rootScope.user.canModifyCustomers
            );
        }

    }

    public client(api: ApiService) {
        return api.customers;
    }

    public waitForRefresh() {
        return true;
    }

    public onSuccess() {
        this.$state.go("kb.customers");
    }

    public onDelete() {
        this.$state.go("kb.customers");
    }
}
